import type { JSX, PropsWithChildren } from 'react';

import styles from './Container.module.css';

export default function InnerContainer({
  children,
}: PropsWithChildren): JSX.Element {
  return <div className={styles.InnerContainer}>{children}</div>;
}
